export let vaxxed = [
  {
    Date: '2022-04-19',
    Location: 'South Africa',
    sisonke_first_dose: 500287,
    JnJ_first_dose: 6954283,
    Pfizer_second_dose: 10720441,
    'DoH_fully-vaxxed_adults': 17710727,
    Fully_vaxxed_total_population: 18175011,
    percent_total_population_fully_vaxxed: 30.14,
  },
  {
    Date: '2022-04-18',
    Location: 'South Africa',
    sisonke_first_dose: 500275,
    JnJ_first_dose: 6948818,
    Pfizer_second_dose: 10708049,
    'DoH_fully-vaxxed_adults': 17696882,
    Fully_vaxxed_total_population: 18157142,
    percent_total_population_fully_vaxxed: 30.11,
  },
  {
    Date: '2022-04-17',
    Location: 'South Africa',
    sisonke_first_dose: 500274,
    JnJ_first_dose: 6948284,
    Pfizer_second_dose: 10706979,
    'DoH_fully-vaxxed_adults': 17695415,
    Fully_vaxxed_total_population: 18155537,
    percent_total_population_fully_vaxxed: 30.11,
  },
  {
    Date: '2022-04-16',
    Location: 'South Africa',
    sisonke_first_dose: 500272,
    JnJ_first_dose: 6948069,
    Pfizer_second_dose: 10706497,
    'DoH_fully-vaxxed_adults': 17694651,
    Fully_vaxxed_total_population: 18154838,
    percent_total_population_fully_vaxxed: 30.1,
  },
  {
    Date: '2022-04-15',
    Location: 'South Africa',
    sisonke_first_dose: 500271,
    JnJ_first_dose: 6947621,
    Pfizer_second_dose: 10705121,
    'DoH_fully-vaxxed_adults': 17692932,
    Fully_vaxxed_total_population: 18153013,
    percent_total_population_fully_vaxxed: 30.1,
  },
  {
    Date: '2022-04-14',
    Location: 'South Africa',
    sisonke_first_dose: 500270,
    JnJ_first_dose: 6947003,
    Pfizer_second_dose: 10704067,
    'DoH_fully-vaxxed_adults': 17691378,
    Fully_vaxxed_total_population: 18151340,
    percent_total_population_fully_vaxxed: 30.1,
  },
  {
    Date: '2022-04-13',
    Location: 'South Africa',
    sisonke_first_dose: 500254,
    JnJ_first_dose: 6942888,
    Pfizer_second_dose: 10693604,
    'DoH_fully-vaxxed_adults': 17680134,
    Fully_vaxxed_total_population: 18136746,
    percent_total_population_fully_vaxxed: 30.07,
  },
  {
    Date: '2022-04-12',
    Location: 'South Africa',
    sisonke_first_dose: 500192,
    JnJ_first_dose: 6530319,
    Pfizer_second_dose: 10663855,
    'DoH_fully-vaxxed_adults': 17651576,
    Fully_vaxxed_total_population: 17694366,
    percent_total_population_fully_vaxxed: 29.34,
  },
  {
    Date: '2022-04-11',
    Location: 'South Africa',
    sisonke_first_dose: 500192,
    JnJ_first_dose: 6530319,
    Pfizer_second_dose: 10663855,
    'DoH_fully-vaxxed_adults': 17651576,
    Fully_vaxxed_total_population: 17694366,
    percent_total_population_fully_vaxxed: 29.34,
  },
  {
    Date: '2022-04-10',
    Location: 'South Africa',
    sisonke_first_dose: 500177,
    JnJ_first_dose: 6925564,
    Pfizer_second_dose: 10651317,
    'DoH_fully-vaxxed_adults': 17639519,
    Fully_vaxxed_total_population: 18077058,
    percent_total_population_fully_vaxxed: 29.98,
  },
  {
    Date: '2022-04-09',
    Location: 'South Africa',
    sisonke_first_dose: 500174,
    JnJ_first_dose: 6924400,
    Pfizer_second_dose: 10649881,
    'DoH_fully-vaxxed_adults': 17637197,
    Fully_vaxxed_total_population: 18074455,
    percent_total_population_fully_vaxxed: 29.97,
  },
  {
    Date: '2022-04-08',
    Location: 'South Africa',
    sisonke_first_dose: 500160,
    JnJ_first_dose: 6915315,
    Pfizer_second_dose: 10628307,
    'DoH_fully-vaxxed_adults': 17614716,
    Fully_vaxxed_total_population: 18043782,
    percent_total_population_fully_vaxxed: 29.92,
  },
  {
    Date: '2022-04-07',
    Location: 'South Africa',
    sisonke_first_dose: 500160,
    JnJ_first_dose: 6915315,
    Pfizer_second_dose: 10628307,
    'DoH_fully-vaxxed_adults': 17614716,
    Fully_vaxxed_total_population: 18043782,
    percent_total_population_fully_vaxxed: 29.92,
  },
  {
    Date: '2022-04-06',
    Location: 'South Africa',
    sisonke_first_dose: 500150,
    JnJ_first_dose: 6908774,
    Pfizer_second_dose: 10612877,
    'DoH_fully-vaxxed_adults': 17598384,
    Fully_vaxxed_total_population: 18021801,
    percent_total_population_fully_vaxxed: 29.88,
  },
  {
    Date: '2022-04-05',
    Location: 'South Africa',
    sisonke_first_dose: 500137,
    JnJ_first_dose: 6902585,
    Pfizer_second_dose: 10598056,
    'DoH_fully-vaxxed_adults': 17581547,
    Fully_vaxxed_total_population: 18000778,
    percent_total_population_fully_vaxxed: 29.85,
  },
  {
    Date: '2022-04-04',
    Location: 'South Africa',
    sisonke_first_dose: 500130,
    JnJ_first_dose: 6896431,
    Pfizer_second_dose: 10585134,
    'DoH_fully-vaxxed_adults': 17564726,
    Fully_vaxxed_total_population: 17981695,
    percent_total_population_fully_vaxxed: 29.82,
  },
  {
    Date: '2022-04-03',
    Location: 'South Africa',
    sisonke_first_dose: 500128,
    JnJ_first_dose: 6891119,
    Pfizer_second_dose: 10569481,
    'DoH_fully-vaxxed_adults': 17549494,
    Fully_vaxxed_total_population: 17960728,
    percent_total_population_fully_vaxxed: 29.78,
  },
  {
    Date: '2022-04-02',
    Location: 'South Africa',
    sisonke_first_dose: 500128,
    JnJ_first_dose: 6890765,
    Pfizer_second_dose: 10568840,
    'DoH_fully-vaxxed_adults': 17548548,
    Fully_vaxxed_total_population: 17959733,
    percent_total_population_fully_vaxxed: 29.78,
  },
  {
    Date: '2022-04-01',
    Location: 'South Africa',
    sisonke_first_dose: 500127,
    JnJ_first_dose: 6889628,
    Pfizer_second_dose: 10564639,
    'DoH_fully-vaxxed_adults': 17544343,
    Fully_vaxxed_total_population: 17954394,
    percent_total_population_fully_vaxxed: 29.77,
  },
  {
    Date: '2022-03-31',
    Location: 'South Africa',
    sisonke_first_dose: 500121,
    JnJ_first_dose: 6883371,
    Pfizer_second_dose: 10545990,
    'DoH_fully-vaxxed_adults': 17526616,
    Fully_vaxxed_total_population: 17929482,
    percent_total_population_fully_vaxxed: 29.73,
  },
  {
    Date: '2022-03-30',
    Location: 'South Africa',
    sisonke_first_dose: 500107,
    JnJ_first_dose: 6875051,
    Pfizer_second_dose: 10523091,
    'DoH_fully-vaxxed_adults': 17503467,
    Fully_vaxxed_total_population: 17898249,
    percent_total_population_fully_vaxxed: 29.68,
  },
  {
    Date: '2022-03-29',
    Location: 'South Africa',
    sisonke_first_dose: 500100,
    JnJ_first_dose: 6866476,
    Pfizer_second_dose: 10498642,
    'DoH_fully-vaxxed_adults': 17479028,
    Fully_vaxxed_total_population: 17865218,
    percent_total_population_fully_vaxxed: 29.62,
  },
  {
    Date: '2022-03-28',
    Location: 'South Africa',
    sisonke_first_dose: 500090,
    JnJ_first_dose: 6858236,
    Pfizer_second_dose: 10475208,
    'DoH_fully-vaxxed_adults': 17455625,
    Fully_vaxxed_total_population: 17833534,
    percent_total_population_fully_vaxxed: 29.57,
  },
  {
    Date: '2022-03-27',
    Location: 'South Africa',
    sisonke_first_dose: 500086,
    JnJ_first_dose: 6850781,
    Pfizer_second_dose: 10451922,
    'DoH_fully-vaxxed_adults': 17431677,
    Fully_vaxxed_total_population: 17802789,
    percent_total_population_fully_vaxxed: 29.52,
  },
  {
    Date: '2022-03-26',
    Location: 'South Africa',
    sisonke_first_dose: 500086,
    JnJ_first_dose: 6850079,
    Pfizer_second_dose: 10450798,
    'DoH_fully-vaxxed_adults': 17431677,
    Fully_vaxxed_total_population: 17800963,
    percent_total_population_fully_vaxxed: 29.52,
  },
  {
    Date: '2022-03-25',
    Location: 'South Africa',
    sisonke_first_dose: 500080,
    JnJ_first_dose: 6848275,
    Pfizer_second_dose: 10445337,
    'DoH_fully-vaxxed_adults': 17425918,
    Fully_vaxxed_total_population: 17793692,
    percent_total_population_fully_vaxxed: 29.51,
  },
  {
    Date: '2022-03-24',
    Location: 'South Africa',
    sisonke_first_dose: 500067,
    JnJ_first_dose: 6841226,
    Pfizer_second_dose: 10420979,
    'DoH_fully-vaxxed_adults': 17403325,
    Fully_vaxxed_total_population: 17762272,
    percent_total_population_fully_vaxxed: 29.45,
  },
  {
    Date: '2022-03-23',
    Location: 'South Africa',
    sisonke_first_dose: 500063,
    JnJ_first_dose: 6832644,
    Pfizer_second_dose: 10395011,
    'DoH_fully-vaxxed_adults': 17377912,
    Fully_vaxxed_total_population: 17727718,
    percent_total_population_fully_vaxxed: 29.4,
  },
  {
    Date: '2022-03-22',
    Location: 'South Africa',
    sisonke_first_dose: 500056,
    JnJ_first_dose: 6824042,
    Pfizer_second_dose: 10370005,
    'DoH_fully-vaxxed_adults': 17352311,
    Fully_vaxxed_total_population: 17694103,
    percent_total_population_fully_vaxxed: 29.34,
  },
  {
    Date: '2022-03-21',
    Location: 'South Africa',
    sisonke_first_dose: 500043,
    JnJ_first_dose: 6816467,
    Pfizer_second_dose: 10348801,
    'DoH_fully-vaxxed_adults': 17329992,
    Fully_vaxxed_total_population: 17665311,
    percent_total_population_fully_vaxxed: 29.29,
  },
  {
    Date: '2022-03-20',
    Location: 'South Africa',
    sisonke_first_dose: 500043,
    JnJ_first_dose: 6815648,
    Pfizer_second_dose: 10347003,
    'DoH_fully-vaxxed_adults': 17326185,
    Fully_vaxxed_total_population: 17662694,
    percent_total_population_fully_vaxxed: 29.29,
  },
  {
    Date: '2022-03-19',
    Location: 'South Africa',
    sisonke_first_dose: 500043,
    JnJ_first_dose: 6814982,
    Pfizer_second_dose: 10345862,
    'DoH_fully-vaxxed_adults': 17326185,
    Fully_vaxxed_total_population: 17660887,
    percent_total_population_fully_vaxxed: 29.29,
  },
  {
    Date: '2022-03-18',
    Location: 'South Africa',
    sisonke_first_dose: 500043,
    JnJ_first_dose: 6813522,
    Pfizer_second_dose: 10341224,
    'DoH_fully-vaxxed_adults': 17321470,
    Fully_vaxxed_total_population: 17654789,
    percent_total_population_fully_vaxxed: 29.28,
  },
  {
    Date: '2022-03-17',
    Location: 'South Africa',
    sisonke_first_dose: 500032,
    JnJ_first_dose: 6807016,
    Pfizer_second_dose: 10321017,
    'DoH_fully-vaxxed_adults': 17301226,
    Fully_vaxxed_total_population: 17628065,
    percent_total_population_fully_vaxxed: 29.23,
  },
  {
    Date: '2022-03-16',
    Location: 'South Africa',
    sisonke_first_dose: 500022,
    JnJ_first_dose: 6800179,
    Pfizer_second_dose: 10302755,
    'DoH_fully-vaxxed_adults': 17281571,
    Fully_vaxxed_total_population: 17602956,
    percent_total_population_fully_vaxxed: 29.19,
  },
  {
    Date: '2022-03-15',
    Location: 'South Africa',
    sisonke_first_dose: 500008,
    JnJ_first_dose: 6792114,
    Pfizer_second_dose: 10284475,
    'DoH_fully-vaxxed_adults': 17260857,
    Fully_vaxxed_total_population: 17576597,
    percent_total_population_fully_vaxxed: 29.15,
  },
  {
    Date: '2022-03-14',
    Location: 'South Africa',
    sisonke_first_dose: 500005,
    JnJ_first_dose: 6785521,
    Pfizer_second_dose: 10267939,
    'DoH_fully-vaxxed_adults': 17241891,
    Fully_vaxxed_total_population: 17553465,
    percent_total_population_fully_vaxxed: 29.11,
  },
  {
    Date: '2022-03-13',
    Location: 'South Africa',
    sisonke_first_dose: 500000,
    JnJ_first_dose: 6778538,
    Pfizer_second_dose: 10252858,
    'DoH_fully-vaxxed_adults': 17223510,
    Fully_vaxxed_total_population: 17531396,
    percent_total_population_fully_vaxxed: 29.07,
  },
  {
    Date: '2022-03-12',
    Location: 'South Africa',
    sisonke_first_dose: 500000,
    JnJ_first_dose: 6777814,
    Pfizer_second_dose: 10251498,
    'DoH_fully-vaxxed_adults': 17221740,
    Fully_vaxxed_total_population: 17529312,
    percent_total_population_fully_vaxxed: 29.07,
  },
  {
    Date: '2022-03-11',
    Location: 'South Africa',
    sisonke_first_dose: 499999,
    JnJ_first_dose: 6776180,
    Pfizer_second_dose: 10246708,
    'DoH_fully-vaxxed_adults': 17216816,
    Fully_vaxxed_total_population: 17522887,
    percent_total_population_fully_vaxxed: 29.06,
  },
  {
    Date: '2022-03-10',
    Location: 'South Africa',
    sisonke_first_dose: 499996,
    JnJ_first_dose: 6768721,
    Pfizer_second_dose: 10229466,
    'DoH_fully-vaxxed_adults': 17196763,
    Fully_vaxxed_total_population: 17498183,
    percent_total_population_fully_vaxxed: 29.02,
  },
  {
    Date: '2022-03-09',
    Location: 'South Africa',
    sisonke_first_dose: 499992,
    JnJ_first_dose: 6760467,
    Pfizer_second_dose: 10212392,
    'DoH_fully-vaxxed_adults': 17176000,
    Fully_vaxxed_total_population: 17472851,
    percent_total_population_fully_vaxxed: 28.97,
  },
  {
    Date: '2022-03-08',
    Location: 'South Africa',
    sisonke_first_dose: 499980,
    JnJ_first_dose: 6752564,
    Pfizer_second_dose: 10195639,
    'DoH_fully-vaxxed_adults': 17156043,
    Fully_vaxxed_total_population: 17448183,
    percent_total_population_fully_vaxxed: 28.93,
  },
  {
    Date: '2022-03-07',
    Location: 'South Africa',
    sisonke_first_dose: 499971,
    JnJ_first_dose: 6744667,
    Pfizer_second_dose: 10178796,
    'DoH_fully-vaxxed_adults': 17135488,
    Fully_vaxxed_total_population: 17423434,
    percent_total_population_fully_vaxxed: 28.89,
  },
  {
    Date: '2022-03-06',
    Location: 'South Africa',
    sisonke_first_dose: 499956,
    JnJ_first_dose: 6736475,
    Pfizer_second_dose: 10161753,
    'DoH_fully-vaxxed_adults': 17114044,
    Fully_vaxxed_total_population: 17398184,
    percent_total_population_fully_vaxxed: 28.85,
  },
  {
    Date: '2022-03-05',
    Location: 'South Africa',
    sisonke_first_dose: 499956,
    JnJ_first_dose: 6735422,
    Pfizer_second_dose: 10160295,
    'DoH_fully-vaxxed_adults': 17111816,
    Fully_vaxxed_total_population: 17395673,
    percent_total_population_fully_vaxxed: 28.85,
  },
  {
    Date: '2022-03-04',
    Location: 'South Africa',
    sisonke_first_dose: 499955,
    JnJ_first_dose: 6733330,
    Pfizer_second_dose: 10153840,
    'DoH_fully-vaxxed_adults': 17105432,
    Fully_vaxxed_total_population: 17387125,
    percent_total_population_fully_vaxxed: 28.83,
  },
  {
    Date: '2022-03-03',
    Location: 'South Africa',
    sisonke_first_dose: 499946,
    JnJ_first_dose: 6725613,
    Pfizer_second_dose: 10102786,
    'DoH_fully-vaxxed_adults': 17081913,
    Fully_vaxxed_total_population: 17328345,
    percent_total_population_fully_vaxxed: 28.73,
  },
  {
    Date: '2022-03-02',
    Location: 'South Africa',
    sisonke_first_dose: 499935,
    JnJ_first_dose: 6716679,
    Pfizer_second_dose: 10112590,
    'DoH_fully-vaxxed_adults': 17057408,
    Fully_vaxxed_total_population: 17329204,
    percent_total_population_fully_vaxxed: 28.74,
  },
  {
    Date: '2022-03-01',
    Location: 'South Africa',
    sisonke_first_dose: 499925,
    JnJ_first_dose: 6708135,
    Pfizer_second_dose: 10093747,
    'DoH_fully-vaxxed_adults': 17034932,
    Fully_vaxxed_total_population: 17301807,
    percent_total_population_fully_vaxxed: 28.69,
  },
  {
    Date: '2022-02-28',
    Location: 'South Africa',
    sisonke_first_dose: 499919,
    JnJ_first_dose: 6698413,
    Pfizer_second_dose: 10075247,
    'DoH_fully-vaxxed_adults': 17011015,
    Fully_vaxxed_total_population: 17273579,
    percent_total_population_fully_vaxxed: 28.64,
  },
  {
    Date: '2022-02-27',
    Location: 'South Africa',
    sisonke_first_dose: 499905,
    JnJ_first_dose: 6688324,
    Pfizer_second_dose: 10054859,
    'DoH_fully-vaxxed_adults': 16982427,
    Fully_vaxxed_total_population: 17243088,
    percent_total_population_fully_vaxxed: 28.59,
  },
  {
    Date: '2022-02-26',
    Location: 'South Africa',
    sisonke_first_dose: 499905,
    JnJ_first_dose: 6686028,
    Pfizer_second_dose: 10053626,
    'DoH_fully-vaxxed_adults': 16982427,
    Fully_vaxxed_total_population: 17239559,
    percent_total_population_fully_vaxxed: 28.59,
  },
  {
    Date: '2022-02-25',
    Location: 'South Africa',
    sisonke_first_dose: 499887,
    JnJ_first_dose: 6633726,
    Pfizer_second_dose: 10001864,
    'DoH_fully-vaxxed_adults': 16920679,
    Fully_vaxxed_total_population: 17135477,
    percent_total_population_fully_vaxxed: 28.41,
  },
  {
    Date: '2022-02-24',
    Location: 'South Africa',
    sisonke_first_dose: 499887,
    JnJ_first_dose: 6633726,
    Pfizer_second_dose: 10001864,
    'DoH_fully-vaxxed_adults': 16920679,
    Fully_vaxxed_total_population: 17135477,
    percent_total_population_fully_vaxxed: 28.41,
  },
  {
    Date: '2022-02-23',
    Location: 'South Africa',
    sisonke_first_dose: 499887,
    JnJ_first_dose: 6633726,
    Pfizer_second_dose: 10001864,
    'DoH_fully-vaxxed_adults': 16920679,
    Fully_vaxxed_total_population: 17135477,
    percent_total_population_fully_vaxxed: 28.41,
  },
  {
    Date: '2022-02-22',
    Location: 'South Africa',
    sisonke_first_dose: 499879,
    JnJ_first_dose: 6648899,
    Pfizer_second_dose: 9980432,
    'DoH_fully-vaxxed_adults': 16892739,
    Fully_vaxxed_total_population: 17129210,
    percent_total_population_fully_vaxxed: 28.4,
  },
  {
    Date: '2022-02-21',
    Location: 'South Africa',
    sisonke_first_dose: 499871,
    JnJ_first_dose: 6637726,
    Pfizer_second_dose: 9959137,
    'DoH_fully-vaxxed_adults': 16866764,
    Fully_vaxxed_total_population: 17096734,
    percent_total_population_fully_vaxxed: 28.35,
  },
  {
    Date: '2022-02-20',
    Location: 'South Africa',
    sisonke_first_dose: 499862,
    JnJ_first_dose: 6626671,
    Pfizer_second_dose: 9940543,
    'DoH_fully-vaxxed_adults': 16843047,
    Fully_vaxxed_total_population: 17067076,
    percent_total_population_fully_vaxxed: 28.3,
  },
  {
    Date: '2022-02-19',
    Location: 'South Africa',
    sisonke_first_dose: 499862,
    JnJ_first_dose: 6624793,
    Pfizer_second_dose: 9938829,
    'DoH_fully-vaxxed_adults': 16840116,
    Fully_vaxxed_total_population: 17063484,
    percent_total_population_fully_vaxxed: 28.3,
  },
  {
    Date: '2022-02-18',
    Location: 'South Africa',
    sisonke_first_dose: 499861,
    JnJ_first_dose: 6621362,
    Pfizer_second_dose: 9932185,
    'DoH_fully-vaxxed_adults': 16833007,
    Fully_vaxxed_total_population: 17053408,
    percent_total_population_fully_vaxxed: 28.28,
  },
  {
    Date: '2022-02-17',
    Location: 'South Africa',
    sisonke_first_dose: 499843,
    JnJ_first_dose: 6610684,
    Pfizer_second_dose: 9911498,
    'DoH_fully-vaxxed_adults': 16808604,
    Fully_vaxxed_total_population: 17022025,
    percent_total_population_fully_vaxxed: 28.23,
  },
  {
    Date: '2022-02-16',
    Location: 'South Africa',
    sisonke_first_dose: 499828,
    JnJ_first_dose: 6598946,
    Pfizer_second_dose: 9893951,
    'DoH_fully-vaxxed_adults': 16784290,
    Fully_vaxxed_total_population: 16992725,
    percent_total_population_fully_vaxxed: 28.18,
  },
  {
    Date: '2022-02-15',
    Location: 'South Africa',
    sisonke_first_dose: 499808,
    JnJ_first_dose: 6587050,
    Pfizer_second_dose: 9876258,
    'DoH_fully-vaxxed_adults': 16759646,
    Fully_vaxxed_total_population: 16963116,
    percent_total_population_fully_vaxxed: 28.13,
  },
  {
    Date: '2022-02-14',
    Location: 'South Africa',
    sisonke_first_dose: 499791,
    JnJ_first_dose: 6576018,
    Pfizer_second_dose: 9859499,
    'DoH_fully-vaxxed_adults': 16735990,
    Fully_vaxxed_total_population: 16935308,
    percent_total_population_fully_vaxxed: 28.08,
  },
  {
    Date: '2022-02-13',
    Location: 'South Africa',
    sisonke_first_dose: 499755,
    JnJ_first_dose: 6564941,
    Pfizer_second_dose: 9844661,
    'DoH_fully-vaxxed_adults': 16713434,
    Fully_vaxxed_total_population: 16909357,
    percent_total_population_fully_vaxxed: 28.04,
  },
  {
    Date: '2022-02-12',
    Location: 'South Africa',
    sisonke_first_dose: 499754,
    JnJ_first_dose: 6564147,
    Pfizer_second_dose: 9843799,
    'DoH_fully-vaxxed_adults': 16712102,
    Fully_vaxxed_total_population: 16907700,
    percent_total_population_fully_vaxxed: 28.04,
  },
  {
    Date: '2022-02-11',
    Location: 'South Africa',
    sisonke_first_dose: 499751,
    JnJ_first_dose: 6561462,
    Pfizer_second_dose: 9838580,
    'DoH_fully-vaxxed_adults': 16706568,
    Fully_vaxxed_total_population: 16899793,
    percent_total_population_fully_vaxxed: 28.02,
  },
  {
    Date: '2022-02-10',
    Location: 'South Africa',
    sisonke_first_dose: 499744,
    JnJ_first_dose: 6550312,
    Pfizer_second_dose: 9823337,
    'DoH_fully-vaxxed_adults': 16684897,
    Fully_vaxxed_total_population: 16873393,
    percent_total_population_fully_vaxxed: 27.98,
  },
  {
    Date: '2022-02-09',
    Location: 'South Africa',
    sisonke_first_dose: 499738,
    JnJ_first_dose: 6538524,
    Pfizer_second_dose: 9808361,
    'DoH_fully-vaxxed_adults': 16662009,
    Fully_vaxxed_total_population: 16846623,
    percent_total_population_fully_vaxxed: 27.94,
  },
  {
    Date: '2022-02-08',
    Location: 'South Africa',
    sisonke_first_dose: 499728,
    JnJ_first_dose: 6525918,
    Pfizer_second_dose: 9791898,
    'DoH_fully-vaxxed_adults': 16637053,
    Fully_vaxxed_total_population: 16817544,
    percent_total_population_fully_vaxxed: 27.89,
  },
  {
    Date: '2022-02-07',
    Location: 'South Africa',
    sisonke_first_dose: 499721,
    JnJ_first_dose: 6513218,
    Pfizer_second_dose: 9776122,
    'DoH_fully-vaxxed_adults': 16612270,
    Fully_vaxxed_total_population: 16789061,
    percent_total_population_fully_vaxxed: 27.84,
  },
  {
    Date: '2022-02-06',
    Location: 'South Africa',
    sisonke_first_dose: 499700,
    JnJ_first_dose: 6499805,
    Pfizer_second_dose: 9763493,
    'DoH_fully-vaxxed_adults': 16589304,
    Fully_vaxxed_total_population: 16762998,
    percent_total_population_fully_vaxxed: 27.8,
  },
  {
    Date: '2022-02-05',
    Location: 'South Africa',
    sisonke_first_dose: 499695,
    JnJ_first_dose: 6498723,
    Pfizer_second_dose: 9762280,
    'DoH_fully-vaxxed_adults': 16587442,
    Fully_vaxxed_total_population: 16760698,
    percent_total_population_fully_vaxxed: 27.79,
  },
  {
    Date: '2022-02-04',
    Location: 'South Africa',
    sisonke_first_dose: 499694,
    JnJ_first_dose: 6495861,
    Pfizer_second_dose: 9756249,
    'DoH_fully-vaxxed_adults': 16581331,
    Fully_vaxxed_total_population: 16751804,
    percent_total_population_fully_vaxxed: 27.78,
  },
  {
    Date: '2022-02-02',
    Location: 'South Africa',
    sisonke_first_dose: 499643,
    JnJ_first_dose: 6473052,
    Pfizer_second_dose: 9720540,
    'DoH_fully-vaxxed_adults': 16533662,
    Fully_vaxxed_total_population: 16693235,
    percent_total_population_fully_vaxxed: 27.68,
  },
  {
    Date: '2022-02-01',
    Location: 'South Africa',
    sisonke_first_dose: 499631,
    JnJ_first_dose: 6460204,
    Pfizer_second_dose: 9699920,
    'DoH_fully-vaxxed_adults': 16505678,
    Fully_vaxxed_total_population: 16659755,
    percent_total_population_fully_vaxxed: 27.63,
  },
  {
    Date: '2022-01-31',
    Location: 'South Africa',
    sisonke_first_dose: 499618,
    JnJ_first_dose: 6447389,
    Pfizer_second_dose: 9678568,
    'DoH_fully-vaxxed_adults': 16477074,
    Fully_vaxxed_total_population: 16625575,
    percent_total_population_fully_vaxxed: 27.57,
  },
  {
    Date: '2022-01-30',
    Location: 'South Africa',
    sisonke_first_dose: 499606,
    JnJ_first_dose: 6434210,
    Pfizer_second_dose: 9656260,
    'DoH_fully-vaxxed_adults': 16446954,
    Fully_vaxxed_total_population: 16590076,
    percent_total_population_fully_vaxxed: 27.51,
  },
  {
    Date: '2022-01-29',
    Location: 'South Africa',
    sisonke_first_dose: 499606,
    JnJ_first_dose: 6432801,
    Pfizer_second_dose: 9654691,
    'DoH_fully-vaxxed_adults': 16444529,
    Fully_vaxxed_total_population: 16587098,
    percent_total_population_fully_vaxxed: 27.51,
  },
  {
    Date: '2022-01-28',
    Location: 'South Africa',
    sisonke_first_dose: 499604,
    JnJ_first_dose: 6428893,
    Pfizer_second_dose: 9645970,
    'DoH_fully-vaxxed_adults': 16435591,
    Fully_vaxxed_total_population: 16574467,
    percent_total_population_fully_vaxxed: 27.48,
  },
  {
    Date: '2022-01-27',
    Location: 'South Africa',
    sisonke_first_dose: 183416,
    JnJ_first_dose: 6415318,
    Pfizer_second_dose: 9619718,
    'DoH_fully-vaxxed_adults': 16403387,
    Fully_vaxxed_total_population: 16218452,
    percent_total_population_fully_vaxxed: 26.89,
  },
  {
    Date: '2022-01-26',
    Location: 'South Africa',
    sisonke_first_dose: 201901,
    JnJ_first_dose: 6401342,
    Pfizer_second_dose: 9600096,
    'DoH_fully-vaxxed_adults': 16374573,
    Fully_vaxxed_total_population: 16203339,
    percent_total_population_fully_vaxxed: 26.87,
  },
  {
    Date: '2022-01-25',
    Location: 'South Africa',
    sisonke_first_dose: 221522,
    JnJ_first_dose: 6386711,
    Pfizer_second_dose: 9572038,
    'DoH_fully-vaxxed_adults': 16338574,
    Fully_vaxxed_total_population: 16180271,
    percent_total_population_fully_vaxxed: 26.83,
  },
  {
    Date: '2022-01-24',
    Location: 'South Africa',
    sisonke_first_dose: 240596,
    JnJ_first_dose: 6371875,
    Pfizer_second_dose: 9541688,
    'DoH_fully-vaxxed_adults': 16300265,
    Fully_vaxxed_total_population: 16154159,
    percent_total_population_fully_vaxxed: 26.79,
  },
  {
    Date: '2022-01-23',
    Location: 'South Africa',
    sisonke_first_dose: 499521,
    JnJ_first_dose: 6356639,
    Pfizer_second_dose: 9512964,
    'DoH_fully-vaxxed_adults': 16262118,
    Fully_vaxxed_total_population: 16369124,
    percent_total_population_fully_vaxxed: 27.14,
  },
  {
    Date: '2022-01-22',
    Location: 'South Africa',
    sisonke_first_dose: 499520,
    JnJ_first_dose: 6355190,
    Pfizer_second_dose: 9511015,
    'DoH_fully-vaxxed_adults': 16259363,
    Fully_vaxxed_total_population: 16365725,
    percent_total_population_fully_vaxxed: 27.14,
  },
  {
    Date: '2022-01-21',
    Location: 'South Africa',
    sisonke_first_dose: 263848,
    JnJ_first_dose: 6351389,
    Pfizer_second_dose: 9500953,
    'DoH_fully-vaxxed_adults': 16248968,
    Fully_vaxxed_total_population: 16116190,
    percent_total_population_fully_vaxxed: 26.72,
  },
  {
    Date: '2022-01-20',
    Location: 'South Africa',
    sisonke_first_dose: 281671,
    JnJ_first_dose: 6337771,
    Pfizer_second_dose: 9466642,
    'DoH_fully-vaxxed_adults': 16208728,
    Fully_vaxxed_total_population: 16086084,
    percent_total_population_fully_vaxxed: 26.67,
  },
  {
    Date: '2022-01-19',
    Location: 'South Africa',
    sisonke_first_dose: 298776,
    JnJ_first_dose: 6321358,
    Pfizer_second_dose: 9434762,
    'DoH_fully-vaxxed_adults': 16165793,
    Fully_vaxxed_total_population: 16054896,
    percent_total_population_fully_vaxxed: 26.62,
  },
  {
    Date: '2022-01-18',
    Location: 'South Africa',
    sisonke_first_dose: 315056,
    JnJ_first_dose: 6308457,
    Pfizer_second_dose: 9405183,
    'DoH_fully-vaxxed_adults': 16125558,
    Fully_vaxxed_total_population: 16028696,
    percent_total_population_fully_vaxxed: 26.58,
  },
  {
    Date: '2022-01-17',
    Location: 'South Africa',
    sisonke_first_dose: 331764,
    JnJ_first_dose: 6292629,
    Pfizer_second_dose: 9371027,
    'DoH_fully-vaxxed_adults': 16080352,
    Fully_vaxxed_total_population: 15995420,
    percent_total_population_fully_vaxxed: 26.52,
  },
  {
    Date: '2022-01-16',
    Location: 'South Africa',
    sisonke_first_dose: 347806,
    JnJ_first_dose: 6277726,
    Pfizer_second_dose: 9336548,
    'DoH_fully-vaxxed_adults': 16036025,
    Fully_vaxxed_total_population: 15962080,
    percent_total_population_fully_vaxxed: 26.47,
  },
  {
    Date: '2022-01-15',
    Location: 'South Africa',
    sisonke_first_dose: 348719,
    JnJ_first_dose: 6276795,
    Pfizer_second_dose: 9334840,
    'DoH_fully-vaxxed_adults': 16033819,
    Fully_vaxxed_total_population: 15960354,
    percent_total_population_fully_vaxxed: 26.47,
  },
  {
    Date: '2022-01-14',
    Location: 'South Africa',
    sisonke_first_dose: 352346,
    JnJ_first_dose: 6273093,
    Pfizer_second_dose: 9325053,
    'DoH_fully-vaxxed_adults': 16022567,
    Fully_vaxxed_total_population: 15950492,
    percent_total_population_fully_vaxxed: 26.45,
  },
  {
    Date: '2022-01-13',
    Location: 'South Africa',
    sisonke_first_dose: 367370,
    JnJ_first_dose: 6257788,
    Pfizer_second_dose: 9289091,
    'DoH_fully-vaxxed_adults': 15976802,
    Fully_vaxxed_total_population: 15914249,
    percent_total_population_fully_vaxxed: 26.39,
  },
  {
    Date: '2022-01-12',
    Location: 'South Africa',
    sisonke_first_dose: 499388,
    JnJ_first_dose: 6241158,
    Pfizer_second_dose: 9254685,
    'DoH_fully-vaxxed_adults': 15929816,
    Fully_vaxxed_total_population: 15995231,
    percent_total_population_fully_vaxxed: 26.52,
  },
  {
    Date: '2022-01-11',
    Location: 'South Africa',
    sisonke_first_dose: 499380,
    JnJ_first_dose: 6225168,
    Pfizer_second_dose: 9219477,
    'DoH_fully-vaxxed_adults': 15882318,
    Fully_vaxxed_total_population: 15944025,
    percent_total_population_fully_vaxxed: 26.44,
  },
  {
    Date: '2022-01-10',
    Location: 'South Africa',
    sisonke_first_dose: 499372,
    JnJ_first_dose: 6208579,
    Pfizer_second_dose: 9181034,
    'DoH_fully-vaxxed_adults': 15832983,
    Fully_vaxxed_total_population: 15888985,
    percent_total_population_fully_vaxxed: 26.35,
  },
  {
    Date: '2022-01-09',
    Location: 'South Africa',
    sisonke_first_dose: 499368,
    JnJ_first_dose: 6192301,
    Pfizer_second_dose: 9146108,
    'DoH_fully-vaxxed_adults': 15786901,
    Fully_vaxxed_total_population: 15837777,
    percent_total_population_fully_vaxxed: 26.26,
  },
  {
    Date: '2022-01-08',
    Location: 'South Africa',
    sisonke_first_dose: 499368,
    JnJ_first_dose: 6190943,
    Pfizer_second_dose: 9144526,
    'DoH_fully-vaxxed_adults': 15784375,
    Fully_vaxxed_total_population: 15834837,
    percent_total_population_fully_vaxxed: 26.26,
  },
  {
    Date: '2022-01-07',
    Location: 'South Africa',
    sisonke_first_dose: 499366,
    JnJ_first_dose: 6365176,
    Pfizer_second_dose: 9139038,
    'DoH_fully-vaxxed_adults': 15775869,
    Fully_vaxxed_total_population: 16003580,
    percent_total_population_fully_vaxxed: 26.54,
  },
  {
    Date: '2022-01-06',
    Location: 'South Africa',
    sisonke_first_dose: 499355,
    JnJ_first_dose: 6172037,
    Pfizer_second_dose: 9111919,
    'DoH_fully-vaxxed_adults': 15737760,
    Fully_vaxxed_total_population: 15783311,
    percent_total_population_fully_vaxxed: 26.17,
  },
  {
    Date: '2022-01-05',
    Location: 'South Africa',
    sisonke_first_dose: 499346,
    JnJ_first_dose: 6157140,
    Pfizer_second_dose: 9088010,
    'DoH_fully-vaxxed_adults': 15702030,
    Fully_vaxxed_total_population: 15744496,
    percent_total_population_fully_vaxxed: 26.11,
  },
  {
    Date: '2022-01-04',
    Location: 'South Africa',
    sisonke_first_dose: 499341,
    JnJ_first_dose: 6142381,
    Pfizer_second_dose: 9065155,
    'DoH_fully-vaxxed_adults': 15666843,
    Fully_vaxxed_total_population: 15706877,
    percent_total_population_fully_vaxxed: 26.05,
  },
  {
    Date: '2022-01-03',
    Location: 'South Africa',
    sisonke_first_dose: 499353,
    JnJ_first_dose: 6117173,
    Pfizer_second_dose: 9023005,
    'DoH_fully-vaxxed_adults': 15602319,
    Fully_vaxxed_total_population: 15639531,
    percent_total_population_fully_vaxxed: 25.93,
  },
  {
    Date: '2022-01-02',
    Location: 'South Africa',
    sisonke_first_dose: 499332,
    JnJ_first_dose: 6116216,
    Pfizer_second_dose: 9023005,
    'DoH_fully-vaxxed_adults': 15602319,
    Fully_vaxxed_total_population: 15638553,
    percent_total_population_fully_vaxxed: 25.93,
  },
  {
    Date: '2022-01-01',
    Location: 'South Africa',
    sisonke_first_dose: 499332,
    JnJ_first_dose: 6116216,
    Pfizer_second_dose: 9023005,
    'DoH_fully-vaxxed_adults': 15602319,
    Fully_vaxxed_total_population: 15638553,
    percent_total_population_fully_vaxxed: 25.93,
  },
  {
    Date: '2021-12-31',
    Location: 'South Africa',
    sisonke_first_dose: 499329,
    JnJ_first_dose: null,
    Pfizer_second_dose: 9014661,
    'DoH_fully-vaxxed_adults': 15590480,
    Fully_vaxxed_total_population: 9513990,
    percent_total_population_fully_vaxxed: 15.78,
  },
  {
    Date: '2021-12-30',
    Location: 'South Africa',
    sisonke_first_dose: 499329,
    JnJ_first_dose: null,
    Pfizer_second_dose: 9014661,
    'DoH_fully-vaxxed_adults': 15590480,
    Fully_vaxxed_total_population: 9513990,
    percent_total_population_fully_vaxxed: 15.78,
  },
  {
    Date: '2021-12-29',
    Location: 'South Africa',
    sisonke_first_dose: 499325,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8997630,
    'DoH_fully-vaxxed_adults': 15566765,
    Fully_vaxxed_total_population: 9496955,
    percent_total_population_fully_vaxxed: 15.75,
  },
  {
    Date: '2021-12-28',
    Location: 'South Africa',
    sisonke_first_dose: 499322,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8975898,
    'DoH_fully-vaxxed_adults': 15537251,
    Fully_vaxxed_total_population: 9475220,
    percent_total_population_fully_vaxxed: 15.71,
  },
  {
    Date: '2021-12-27',
    Location: 'South Africa',
    sisonke_first_dose: 499319,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8949863,
    'DoH_fully-vaxxed_adults': 15505006,
    Fully_vaxxed_total_population: 9449182,
    percent_total_population_fully_vaxxed: 15.67,
  },
  {
    Date: '2021-12-26',
    Location: 'South Africa',
    sisonke_first_dose: 499319,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8948494,
    'DoH_fully-vaxxed_adults': 15503044,
    Fully_vaxxed_total_population: 9447813,
    percent_total_population_fully_vaxxed: 15.67,
  },
  {
    Date: '2021-12-25',
    Location: 'South Africa',
    sisonke_first_dose: 499319,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8948158,
    'DoH_fully-vaxxed_adults': 15502371,
    Fully_vaxxed_total_population: 9447477,
    percent_total_population_fully_vaxxed: 15.67,
  },
  {
    Date: '2021-12-24',
    Location: 'South Africa',
    sisonke_first_dose: 499319,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8947760,
    'DoH_fully-vaxxed_adults': 15501612,
    Fully_vaxxed_total_population: 9447079,
    percent_total_population_fully_vaxxed: 15.67,
  },
  {
    Date: '2021-12-23',
    Location: 'South Africa',
    sisonke_first_dose: 499308,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8937215,
    'DoH_fully-vaxxed_adults': 15488743,
    Fully_vaxxed_total_population: 9436523,
    percent_total_population_fully_vaxxed: 15.65,
  },
  {
    Date: '2021-12-22',
    Location: 'South Africa',
    sisonke_first_dose: 499254,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8917964,
    'DoH_fully-vaxxed_adults': 15463240,
    Fully_vaxxed_total_population: 9417218,
    percent_total_population_fully_vaxxed: 15.62,
  },
  {
    Date: '2021-12-21',
    Location: 'South Africa',
    sisonke_first_dose: 499215,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8893506,
    'DoH_fully-vaxxed_adults': 15428274,
    Fully_vaxxed_total_population: 9392721,
    percent_total_population_fully_vaxxed: 15.58,
  },
  {
    Date: '2021-12-20',
    Location: 'South Africa',
    sisonke_first_dose: 499212,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8867252,
    'DoH_fully-vaxxed_adults': 15349159,
    Fully_vaxxed_total_population: 9366464,
    percent_total_population_fully_vaxxed: 15.53,
  },
  {
    Date: '2021-12-19',
    Location: 'South Africa',
    sisonke_first_dose: 499203,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8839390,
    'DoH_fully-vaxxed_adults': 15349159,
    Fully_vaxxed_total_population: 9338593,
    percent_total_population_fully_vaxxed: 15.49,
  },
  {
    Date: '2021-12-18',
    Location: 'South Africa',
    sisonke_first_dose: 499203,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8837808,
    'DoH_fully-vaxxed_adults': 15345781,
    Fully_vaxxed_total_population: 9337011,
    percent_total_population_fully_vaxxed: 15.48,
  },
  {
    Date: '2021-12-17',
    Location: 'South Africa',
    sisonke_first_dose: 499204,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8831668,
    'DoH_fully-vaxxed_adults': 15336058,
    Fully_vaxxed_total_population: 9330872,
    percent_total_population_fully_vaxxed: 15.47,
  },
  {
    Date: '2021-12-16',
    Location: 'South Africa',
    sisonke_first_dose: 499175,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8803605,
    'DoH_fully-vaxxed_adults': 15297711,
    Fully_vaxxed_total_population: 9302780,
    percent_total_population_fully_vaxxed: 15.43,
  },
  {
    Date: '2021-12-15',
    Location: 'South Africa',
    sisonke_first_dose: 499170,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8800238,
    'DoH_fully-vaxxed_adults': 15290260,
    Fully_vaxxed_total_population: 9299408,
    percent_total_population_fully_vaxxed: 15.42,
  },
  {
    Date: '2021-12-14',
    Location: 'South Africa',
    sisonke_first_dose: 503275,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8767875,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 9271150,
    percent_total_population_fully_vaxxed: 15.37,
  },
  {
    Date: '2021-12-15',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8800238,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 8800238,
    percent_total_population_fully_vaxxed: 14.59,
  },
  {
    Date: '2021-12-14',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8767875,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 8767875,
    percent_total_population_fully_vaxxed: 14.54,
  },
  {
    Date: '2021-12-13',
    Location: 'South Africa',
    sisonke_first_dose: 498840,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8735806,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 9234646,
    percent_total_population_fully_vaxxed: 15.31,
  },
  {
    Date: '2021-12-12',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8711278,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 8711278,
    percent_total_population_fully_vaxxed: 14.45,
  },
  {
    Date: '2021-12-11',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8708337,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 8708337,
    percent_total_population_fully_vaxxed: 14.44,
  },
  {
    Date: '2021-12-10',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8699010,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 8699010,
    percent_total_population_fully_vaxxed: 14.42,
  },
  {
    Date: '2021-12-09',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8661135,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 8661135,
    percent_total_population_fully_vaxxed: 14.36,
  },
  {
    Date: '2021-12-08',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8624318,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 8624318,
    percent_total_population_fully_vaxxed: 14.3,
  },
  {
    Date: '2021-12-07',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8586212,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 8586212,
    percent_total_population_fully_vaxxed: 14.24,
  },
  {
    Date: '2021-12-06',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8545633,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 8545633,
    percent_total_population_fully_vaxxed: 14.17,
  },
  {
    Date: '2021-12-05',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8508238,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 8508238,
    percent_total_population_fully_vaxxed: 14.11,
  },
  {
    Date: '2021-12-04',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8504300,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 8504300,
    percent_total_population_fully_vaxxed: 14.1,
  },
  {
    Date: '2021-12-03',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8491305,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 8491305,
    percent_total_population_fully_vaxxed: 14.08,
  },
  {
    Date: '2021-12-02',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8448506,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 8448506,
    percent_total_population_fully_vaxxed: 14.01,
  },
  {
    Date: '2021-12-01',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8405359,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 8405359,
    percent_total_population_fully_vaxxed: 13.94,
  },
  {
    Date: '2021-11-30',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8359689,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 8359689,
    percent_total_population_fully_vaxxed: 13.86,
  },
  {
    Date: '2021-11-29',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8309232,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 8309232,
    percent_total_population_fully_vaxxed: 13.78,
  },
  {
    Date: '2021-11-28',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8259228,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 8259228,
    percent_total_population_fully_vaxxed: 13.7,
  },
  {
    Date: '2021-11-27',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8256019,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 8256019,
    percent_total_population_fully_vaxxed: 13.69,
  },
  {
    Date: '2021-11-26',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8244677,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 8244677,
    percent_total_population_fully_vaxxed: 13.67,
  },
  {
    Date: '2021-11-25',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8196105,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 8196105,
    percent_total_population_fully_vaxxed: 13.59,
  },
  {
    Date: '2021-11-24',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8145018,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 8145018,
    percent_total_population_fully_vaxxed: 13.51,
  },
  {
    Date: '2021-11-23',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8093164,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 8093164,
    percent_total_population_fully_vaxxed: 13.42,
  },
  {
    Date: '2021-11-22',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 8041567,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 8041567,
    percent_total_population_fully_vaxxed: 13.33,
  },
  {
    Date: '2021-11-21',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 7993491,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 7993491,
    percent_total_population_fully_vaxxed: 13.26,
  },
  {
    Date: '2021-11-20',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 7990007,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 7990007,
    percent_total_population_fully_vaxxed: 13.25,
  },
  {
    Date: '2021-11-19',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 7976572,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 7976572,
    percent_total_population_fully_vaxxed: 13.23,
  },
  {
    Date: '2021-11-18',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 7921034,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 7921034,
    percent_total_population_fully_vaxxed: 13.13,
  },
  {
    Date: '2021-11-17',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 7867206,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 7867206,
    percent_total_population_fully_vaxxed: 13.05,
  },
  {
    Date: '2021-11-16',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 7811761,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 7811761,
    percent_total_population_fully_vaxxed: 12.95,
  },
  {
    Date: '2021-11-15',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 7755262,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 7755262,
    percent_total_population_fully_vaxxed: 12.86,
  },
  {
    Date: '2021-11-14',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 7698549,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 7698549,
    percent_total_population_fully_vaxxed: 12.77,
  },
  {
    Date: '2021-11-13',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 7690618,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 7690618,
    percent_total_population_fully_vaxxed: 12.75,
  },
  {
    Date: '2021-11-12',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 7666263,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 7666263,
    percent_total_population_fully_vaxxed: 12.71,
  },
  {
    Date: '2021-11-11',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 7603801,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 7603801,
    percent_total_population_fully_vaxxed: 12.61,
  },
  {
    Date: '2021-11-10',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 7544654,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 7544654,
    percent_total_population_fully_vaxxed: 12.51,
  },
  {
    Date: '2021-11-09',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 7484451,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 7484451,
    percent_total_population_fully_vaxxed: 12.41,
  },
  {
    Date: '2021-11-08',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 7424150,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 7424150,
    percent_total_population_fully_vaxxed: 12.31,
  },
  {
    Date: '2021-11-07',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 7372697,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 7372697,
    percent_total_population_fully_vaxxed: 12.23,
  },
  {
    Date: '2021-11-06',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 7369372,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 7369372,
    percent_total_population_fully_vaxxed: 12.22,
  },
  {
    Date: '2021-11-05',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 7357628,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 7357628,
    percent_total_population_fully_vaxxed: 12.2,
  },
  {
    Date: '2021-11-04',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 7309593,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 7309593,
    percent_total_population_fully_vaxxed: 12.12,
  },
  {
    Date: '2021-11-03',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 7237295,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 7237295,
    percent_total_population_fully_vaxxed: 12,
  },
  {
    Date: '2021-11-02',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 7157371,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 7157371,
    percent_total_population_fully_vaxxed: 11.87,
  },
  {
    Date: '2021-11-01',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 7067136,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 7067136,
    percent_total_population_fully_vaxxed: 11.72,
  },
  {
    Date: '2021-10-31',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 7052854,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 7052854,
    percent_total_population_fully_vaxxed: 11.7,
  },
  {
    Date: '2021-10-30',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 7048522,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 7048522,
    percent_total_population_fully_vaxxed: 11.69,
  },
  {
    Date: '2021-10-29',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 7030773,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 7030773,
    percent_total_population_fully_vaxxed: 11.66,
  },
  {
    Date: '2021-10-28',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 6940950,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 6940950,
    percent_total_population_fully_vaxxed: 11.51,
  },
  {
    Date: '2021-10-27',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 6846601,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 6846601,
    percent_total_population_fully_vaxxed: 11.35,
  },
  {
    Date: '2021-10-26',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 6748791,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 6748791,
    percent_total_population_fully_vaxxed: 11.19,
  },
  {
    Date: '2021-10-25',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 6649220,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 6649220,
    percent_total_population_fully_vaxxed: 11.03,
  },
  {
    Date: '2021-10-24',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 6562611,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 6562611,
    percent_total_population_fully_vaxxed: 10.88,
  },
  {
    Date: '2021-10-23',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 6557230,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 6557230,
    percent_total_population_fully_vaxxed: 10.87,
  },
  {
    Date: '2021-10-22',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 6534665,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 6534665,
    percent_total_population_fully_vaxxed: 10.84,
  },
  {
    Date: '2021-10-21',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 6442257,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 6442257,
    percent_total_population_fully_vaxxed: 10.68,
  },
  {
    Date: '2021-10-20',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 6353953,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 6353953,
    percent_total_population_fully_vaxxed: 10.54,
  },
  {
    Date: '2021-10-19',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 6267440,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 6267440,
    percent_total_population_fully_vaxxed: 10.39,
  },
  {
    Date: '2021-10-18',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 6183642,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 6183642,
    percent_total_population_fully_vaxxed: 10.25,
  },
  {
    Date: '2021-10-17',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 6102310,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 6102310,
    percent_total_population_fully_vaxxed: 10.12,
  },
  {
    Date: '2021-10-16',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 6095501,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 6095501,
    percent_total_population_fully_vaxxed: 10.11,
  },
  {
    Date: '2021-10-15',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 6073810,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 6073810,
    percent_total_population_fully_vaxxed: 10.07,
  },
  {
    Date: '2021-10-14',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 5970535,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 5970535,
    percent_total_population_fully_vaxxed: 9.9,
  },
  {
    Date: '2021-10-13',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 5868849,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 5868849,
    percent_total_population_fully_vaxxed: 9.73,
  },
  {
    Date: '2021-10-12',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 5772508,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 5772508,
    percent_total_population_fully_vaxxed: 9.57,
  },
  {
    Date: '2021-10-11',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 5671676,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 5671676,
    percent_total_population_fully_vaxxed: 9.4,
  },
  {
    Date: '2021-10-10',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 5574958,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 5574958,
    percent_total_population_fully_vaxxed: 9.24,
  },
  {
    Date: '2021-10-09',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 5565700,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 5565700,
    percent_total_population_fully_vaxxed: 9.23,
  },
  {
    Date: '2021-10-08',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 5541666,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 5541666,
    percent_total_population_fully_vaxxed: 9.19,
  },
  {
    Date: '2021-10-07',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 5432445,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 5432445,
    percent_total_population_fully_vaxxed: 9.01,
  },
  {
    Date: '2021-10-06',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 5328396,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 5328396,
    percent_total_population_fully_vaxxed: 8.84,
  },
  {
    Date: '2021-10-05',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 5222788,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 5222788,
    percent_total_population_fully_vaxxed: 8.66,
  },
  {
    Date: '2021-10-04',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 5123868,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 5123868,
    percent_total_population_fully_vaxxed: 8.5,
  },
  {
    Date: '2021-10-03',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 5034885,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 5034885,
    percent_total_population_fully_vaxxed: 8.35,
  },
  {
    Date: '2021-10-02',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 5022742,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 5022742,
    percent_total_population_fully_vaxxed: 8.33,
  },
  {
    Date: '2021-10-01',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 4993813,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 4993813,
    percent_total_population_fully_vaxxed: 8.28,
  },
  {
    Date: '2021-09-30',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 4912082,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 4912082,
    percent_total_population_fully_vaxxed: 8.15,
  },
  {
    Date: '2021-09-29',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 4854834,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 4854834,
    percent_total_population_fully_vaxxed: 8.05,
  },
  {
    Date: '2021-09-28',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 4794920,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 4794920,
    percent_total_population_fully_vaxxed: 7.95,
  },
  {
    Date: '2021-09-27',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 4731224,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 4731224,
    percent_total_population_fully_vaxxed: 7.85,
  },
  {
    Date: '2021-09-26',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 4659962,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 4659962,
    percent_total_population_fully_vaxxed: 7.73,
  },
  {
    Date: '2021-09-25',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 4655784,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 4655784,
    percent_total_population_fully_vaxxed: 7.72,
  },
  {
    Date: '2021-09-24',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 4645378,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 4645378,
    percent_total_population_fully_vaxxed: 7.7,
  },
  {
    Date: '2021-09-23',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 4639312,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 4639312,
    percent_total_population_fully_vaxxed: 7.69,
  },
  {
    Date: '2021-09-22',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 4573707,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 4573707,
    percent_total_population_fully_vaxxed: 7.58,
  },
  {
    Date: '2021-09-21',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 4509674,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 4509674,
    percent_total_population_fully_vaxxed: 7.48,
  },
  {
    Date: '2021-09-20',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 4450921,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 4450921,
    percent_total_population_fully_vaxxed: 7.38,
  },
  {
    Date: '2021-09-19',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 4413374,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 4413374,
    percent_total_population_fully_vaxxed: 7.32,
  },
  {
    Date: '2021-09-18',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 4407384,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 4407384,
    percent_total_population_fully_vaxxed: 7.31,
  },
  {
    Date: '2021-09-17',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 4392322,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 4392322,
    percent_total_population_fully_vaxxed: 7.28,
  },
  {
    Date: '2021-09-16',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 4316748,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 4316748,
    percent_total_population_fully_vaxxed: 7.16,
  },
  {
    Date: '2021-09-15',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 4240258,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 4240258,
    percent_total_population_fully_vaxxed: 7.03,
  },
  {
    Date: '2021-09-14',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 4154753,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 4154753,
    percent_total_population_fully_vaxxed: 6.89,
  },
  {
    Date: '2021-09-13',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 4062312,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 4062312,
    percent_total_population_fully_vaxxed: 6.74,
  },
  {
    Date: '2021-09-12',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 3970216,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 3970216,
    percent_total_population_fully_vaxxed: 6.58,
  },
  {
    Date: '2021-09-11',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 3962898,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 3962898,
    percent_total_population_fully_vaxxed: 6.57,
  },
  {
    Date: '2021-09-10',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 3945691,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 3945691,
    percent_total_population_fully_vaxxed: 6.54,
  },
  {
    Date: '2021-09-09',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 3856737,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 3856737,
    percent_total_population_fully_vaxxed: 6.4,
  },
  {
    Date: '2021-09-08',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 3766356,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 3766356,
    percent_total_population_fully_vaxxed: 6.25,
  },
  {
    Date: '2021-09-07',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 3674071,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 3674071,
    percent_total_population_fully_vaxxed: 6.09,
  },
  {
    Date: '2021-09-06',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 3587390,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 3587390,
    percent_total_population_fully_vaxxed: 5.95,
  },
  {
    Date: '2021-09-05',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 3493173,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 3493173,
    percent_total_population_fully_vaxxed: 5.79,
  },
  {
    Date: '2021-09-04',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 3485021,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 3485021,
    percent_total_population_fully_vaxxed: 5.78,
  },
  {
    Date: '2021-09-03',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 3467697,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 3467697,
    percent_total_population_fully_vaxxed: 5.75,
  },
  {
    Date: '2021-09-02',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 3370613,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 3370613,
    percent_total_population_fully_vaxxed: 5.59,
  },
  {
    Date: '2021-09-01',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 3260376,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 3260376,
    percent_total_population_fully_vaxxed: 5.41,
  },
  {
    Date: '2021-08-31',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 3150340,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 3150340,
    percent_total_population_fully_vaxxed: 5.22,
  },
  {
    Date: '2021-08-30',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 3036471,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 3036471,
    percent_total_population_fully_vaxxed: 5.04,
  },
  {
    Date: '2021-08-29',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 2922180,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 2922180,
    percent_total_population_fully_vaxxed: 4.85,
  },
  {
    Date: '2021-08-28',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 2913722,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 2913722,
    percent_total_population_fully_vaxxed: 4.83,
  },
  {
    Date: '2021-08-27',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 2898552,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 2898552,
    percent_total_population_fully_vaxxed: 4.81,
  },
  {
    Date: '2021-08-26',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 2807736,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 2807736,
    percent_total_population_fully_vaxxed: 4.66,
  },
  {
    Date: '2021-08-25',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 2719037,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 2719037,
    percent_total_population_fully_vaxxed: 4.51,
  },
  {
    Date: '2021-08-24',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 2636527,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 2636527,
    percent_total_population_fully_vaxxed: 4.37,
  },
  {
    Date: '2021-08-23',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 2550434,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 2550434,
    percent_total_population_fully_vaxxed: 4.23,
  },
  {
    Date: '2021-08-22',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 2461841,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 2461841,
    percent_total_population_fully_vaxxed: 4.08,
  },
  {
    Date: '2021-08-21',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 2456257,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 2456257,
    percent_total_population_fully_vaxxed: 4.07,
  },
  {
    Date: '2021-08-20',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 2444879,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 2444879,
    percent_total_population_fully_vaxxed: 4.05,
  },
  {
    Date: '2021-08-19',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 2359096,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 2359096,
    percent_total_population_fully_vaxxed: 3.91,
  },
  {
    Date: '2021-08-18',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 2259813,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 2259813,
    percent_total_population_fully_vaxxed: 3.75,
  },
  {
    Date: '2021-08-17',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 2157935,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 2157935,
    percent_total_population_fully_vaxxed: 3.58,
  },
  {
    Date: '2021-08-16',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 2071506,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 2071506,
    percent_total_population_fully_vaxxed: 3.44,
  },
  {
    Date: '2021-08-15',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 1998080,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 1998080,
    percent_total_population_fully_vaxxed: 3.31,
  },
  {
    Date: '2021-08-14',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 1993359,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 1993359,
    percent_total_population_fully_vaxxed: 3.31,
  },
  {
    Date: '2021-08-13',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 1987232,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 1987232,
    percent_total_population_fully_vaxxed: 3.3,
  },
  {
    Date: '2021-08-12',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 1936711,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 1936711,
    percent_total_population_fully_vaxxed: 3.21,
  },
  {
    Date: '2021-08-11',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 1877572,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 1877572,
    percent_total_population_fully_vaxxed: 3.11,
  },
  {
    Date: '2021-08-10',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 1816149,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 1816149,
    percent_total_population_fully_vaxxed: 3.01,
  },
  {
    Date: '2021-08-09',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 1741197,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 1741197,
    percent_total_population_fully_vaxxed: 2.89,
  },
  {
    Date: '2021-08-08',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 1736035,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 1736035,
    percent_total_population_fully_vaxxed: 2.88,
  },
  {
    Date: '2021-08-07',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 1734615,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 1734615,
    percent_total_population_fully_vaxxed: 2.88,
  },
  {
    Date: '2021-08-06',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 1730123,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 1730123,
    percent_total_population_fully_vaxxed: 2.87,
  },
  {
    Date: '2021-08-05',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 1689757,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 1689757,
    percent_total_population_fully_vaxxed: 2.8,
  },
  {
    Date: '2021-08-04',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 1635970,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 1635970,
    percent_total_population_fully_vaxxed: 2.71,
  },
  {
    Date: '2021-08-03',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 1578014,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 1578014,
    percent_total_population_fully_vaxxed: 2.62,
  },
  {
    Date: '2021-08-02',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 1511666,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 1511666,
    percent_total_population_fully_vaxxed: 2.51,
  },
  {
    Date: '2021-08-01',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 1443832,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 1443832,
    percent_total_population_fully_vaxxed: 2.39,
  },
  {
    Date: '2021-07-31',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 1440942,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 1440942,
    percent_total_population_fully_vaxxed: 2.39,
  },
  {
    Date: '2021-07-30',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 1435335,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 1435335,
    percent_total_population_fully_vaxxed: 2.38,
  },
  {
    Date: '2021-07-29',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 1376285,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 1376285,
    percent_total_population_fully_vaxxed: 2.28,
  },
  {
    Date: '2021-07-28',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 1304498,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 1304498,
    percent_total_population_fully_vaxxed: 2.16,
  },
  {
    Date: '2021-07-27',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 1273740,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 1273740,
    percent_total_population_fully_vaxxed: 2.11,
  },
  {
    Date: '2021-07-26',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 1194931,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 1194931,
    percent_total_population_fully_vaxxed: 1.98,
  },
  {
    Date: '2021-07-25',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 1117403,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 1117403,
    percent_total_population_fully_vaxxed: 1.85,
  },
  {
    Date: '2021-07-24',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 1113539,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 1113539,
    percent_total_population_fully_vaxxed: 1.85,
  },
  {
    Date: '2021-07-23',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 1105618,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 1105618,
    percent_total_population_fully_vaxxed: 1.83,
  },
  {
    Date: '2021-07-22',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 1039313,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 1039313,
    percent_total_population_fully_vaxxed: 1.72,
  },
  {
    Date: '2021-07-21',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 958675,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 958675,
    percent_total_population_fully_vaxxed: 1.59,
  },
  {
    Date: '2021-07-20',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 870412,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 870412,
    percent_total_population_fully_vaxxed: 1.44,
  },
  {
    Date: '2021-07-19',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 794144,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 794144,
    percent_total_population_fully_vaxxed: 1.32,
  },
  {
    Date: '2021-07-18',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 718989,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 718989,
    percent_total_population_fully_vaxxed: 1.19,
  },
  {
    Date: '2021-07-17',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 715940,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 715940,
    percent_total_population_fully_vaxxed: 1.19,
  },
  {
    Date: '2021-07-16',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 710750,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 710750,
    percent_total_population_fully_vaxxed: 1.18,
  },
  {
    Date: '2021-07-15',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 657334,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 657334,
    percent_total_population_fully_vaxxed: 1.09,
  },
  {
    Date: '2021-07-14',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 593958,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 593958,
    percent_total_population_fully_vaxxed: 0.98,
  },
  {
    Date: '2021-07-13',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 540202,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 540202,
    percent_total_population_fully_vaxxed: 0.9,
  },
  {
    Date: '2021-07-12',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 496842,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 496842,
    percent_total_population_fully_vaxxed: 0.82,
  },
  {
    Date: '2021-07-11',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 452728,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 452728,
    percent_total_population_fully_vaxxed: 0.75,
  },
  {
    Date: '2021-07-10',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 450765,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 450765,
    percent_total_population_fully_vaxxed: 0.75,
  },
  {
    Date: '2021-07-09',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 447011,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 447011,
    percent_total_population_fully_vaxxed: 0.74,
  },
  {
    Date: '2021-07-08',
    Location: 'South Africa',
    sisonke_first_dose: null,
    JnJ_first_dose: null,
    Pfizer_second_dose: 378403,
    'DoH_fully-vaxxed_adults': null,
    Fully_vaxxed_total_population: 378403,
    percent_total_population_fully_vaxxed: 0.63,
  },
]
